import React from 'react';
import { GetAppRounded as DownloadIcon } from '@material-ui/icons';
import { IconButton, makeStyles } from '@material-ui/core';
import Button from '../../../components/Buttons/Button';
import AutoCompleteCorrespondent from '../../../components/AutoComplete/AutoCompleteCorrespondent';
import AutoCompleteAccountNo from '../../../components/AutoComplete/AutoCompleteAccountNo';
import AutoCompleteAccountName from '../../../components/AutoComplete/AutoCompleteAccountName';
import AutoCompleteMasterAccountNo from '../../../components/AutoComplete/AutoCompleteMasterAccountNo';
import AutoCompleteBranch from '../../../components/AutoComplete/AutoCompleteBranch';
import AutoCompleteRep from '../../../components/AutoComplete/AutoCompleteRep';
import SelectMonth from '../../../components/Dropdown/SelectMonth';
import Text from '../../../components/Typography/Text';
import TextField from '../../../components/Textfields/TextField';
import ReportDownloadModal from '../../../components/Modals/ReportDownloadModal';
import {
  notifyInfo,
  notifyError,
  notifySuccess,
} from '../../../components/Messages/Notification';
import { monthNames } from '../../../lib/data/common';
import { listStatement } from '../../../services/StatementService';
import QueryParam from '../../../services/QueryParamService';
import { GridTitleStatement } from '../../../components/contants/GridTitle';
import Table, {
  tempFilteredRows,
  columnType,
} from '../../../components/ClearingTable/Table';
import color from '../../../assets/css/colors';
import fontFamily from '../../../assets/css/fonts';
import { downloadMonthlyStatement } from '../../../services/StatementService';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 800,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottom: '1px solid #ccc',
    display: 'flex',
    '& div:nth-child(1)': {
      flex: 1,
    },
    '& div:nth-child(2)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {
          fill: color.primary.main,
        },
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    fontFamily: fontFamily.headers,
    '& p': {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 'auto',
    },
  },
  closeButton: {
    '& button': {
      marginTop: '-4px !important',
    },
  },
}));

export default function Statement() {
  const classes = useStyles();

  const [lockTable, setLockTable] = React.useState(true);
  const [pagination, setPagination] = React.useState({});
  const [totalRows, setTotalRows] = React.useState(0);
  const [searchDataCsv, setSearchDataCsv] = React.useState([]);

  var currentDate = new Date();
  var previousMonth = currentDate.getMonth();

  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState(false);

  const [loading, setLoading] = React.useState({
    search: false,
    download: false,
  });

  const [downloadData, setDownloadData] = React.useState({
    accountId: '',
    tradeDate: '',
  });

  const [searchData, setSearchData] = React.useState(
    QueryParam.get({
      month: monthNames[previousMonth],
      year: currentDate.getFullYear(),
      correspondent: '',
      branch: '',
      accountNo: '',
      masterAccountNo: '',
      rep: '',
      accountName: '',
    })
  );

  const init = () => {
    const searchParameters = localStorage.getItem('search_data');

    const {
      correspondent,
      branch,
      accountNo,
      masterAccountNo,
      rep,
      accountName,
      month,
      year,
    } = searchParameters ? JSON.parse(searchParameters) : searchData;

    setSearchData({
      ...searchData,
      month: month ? month : monthNames[previousMonth],
      year: year ? year : currentDate.getFullYear(),
      correspondent: correspondent ? correspondent : '',
      branch: branch ? branch : '',
      accountNo: accountNo ? accountNo : '',
      masterAccountNo: masterAccountNo ? masterAccountNo : '',
      rep: rep ? rep : '',
      accountName: accountName ? accountName : '',
    });
  };

  React.useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      name: 'actions',
      label: 'Actions',
      type: columnType.buttons,
      options: {
        customBodyRenderLite: (dataIndex, rowIndex, tableManager) => {
          const month = searchData.month;
          const year = searchData.year;

          return (
            <div>
              <div style={{ padding: 5 }}>
                <IconButton
                  aria-label="download"
                  onClick={() =>
                    handleDownloadStatementReport(
                      tempFilteredRows[dataIndex]?.accountId,
                      month,
                      year,
                      rowIndex
                    )
                  }
                >
                  <DownloadIcon style={{ height: 24, width: 24 }} />
                </IconButton>
              </div>
            </div>
          );
        },
        sort: false,
      },
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
    },
    {
      name: 'branch',
      label: 'Branch',
    },
    {
      name: 'accountNo',
      label: 'Account No',
    },
    {
      name: 'accountName',
      label: 'Account Name',
    },
    {
      name: 'masterAccountNo',
      label: 'Master Account No',
    },
    {
      name: 'rep',
      label: 'Rep/Advisor',
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    serverSide: true,
    isRowSelectable: () => !loading.download,
    customToolbarSelect: (selectedRows) => {
      return (
        <div className={classes.grdRow} style={{ marginRight: 30, padding: 0 }}>
          <div className={classes.grdCellNone}>
            <Button
              id="batch"
              label={'BATCH DOWNLOAD'}
              onClick={() => {
                handleBatchDownloadStatementReport(
                  selectedRows.data,
                  selectedRows.data.map((d) => d.dataIndex)
                );
              }}
            />
          </div>
        </div>
      );
    },
  };

  const handleSearchDataChange = (e) => {
    const input = e.currentTarget.name ? e.currentTarget : e.target;

    setSearchData({ ...searchData, [input.name]: input.value });
  };

  const handleSearch = async (paginationChange) => {
    let valid = true;

    if (searchData.month === '') {
      notifyError('Month is required.');
      valid = false;
    }

    if (searchData.year === '') {
      notifyError('Year is required.');
      valid = false;
    }

    if (!valid) {
      return;
    }

    try {
      setLoading({ ...loading, search: true });
      if (paginationChange !== true) {
        setLockTable(false);
      }
      if (paginationChange === true) {
        if (lockTable === true) {
          return;
        }
      }

      QueryParam.set(searchData);
      let paginationCopy = {
        ...pagination,
        reload: false,
        pageNo: paginationChange === true ? pagination.pageNo : 0,
        rowsPerPage: pagination.rowsPerPage || 100,
      };

      localStorage.setItem('search_data', JSON.stringify(searchData));

      const data = await listStatement(searchData, paginationCopy);
      setSearchDataCsv(searchData);
      setRows(data.statementsList);

      paginationCopy.count = data.totalRows;
      setPagination(paginationCopy);
      setTotalRows(data.totalRows);

      if (paginationChange !== true) {
        notifyInfo(
          data.statementsList.length > 0
            ? data.statementsList.length + ' search result(s)'
            : 'No records found.'
        );
      }
    } catch (error) {
      setLoading({ ...loading, search: false });
      notifyError(error.message);
      console.error(error);
      return;
    } finally {
      setLoading({ ...loading, search: false });
    }
  };

  const handleDownloadStatementReport = async (accountId, month, year, dataIndex) => {
    setOpen(true);

    setDownloadData({
      accountId: accountId,
      month: month,
      year: year,
      dataIndex: dataIndex,
    });
  };

  const handleBatchDownloadStatementReport = async (selected, index) => {
    const param = {
      month: searchData.month,
      year: searchData.year,
    };
    const selectedIds = [];

    selected.forEach((data) => {
      selectedIds.push(tempFilteredRows[data.dataIndex]?.accountId);
    });

    try {
      for (let i = 0; i < selectedIds.length; i++) {
        await downloadMonthlyStatement(selectedIds[i], param);
      }
      notifySuccess('Statement Download is Completed');
    } catch (error) {
      console.error(error);
      notifyError(error.message);
    }
  };

  const getCsvData = async () => {
    if (lockTable === true) {
      return [];
    }
    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: 0,
      rowsPerPage: totalRows,
    };

    const data = await listStatement(searchDataCsv, paginationCopy);

    return data.statementsList;
  };

  return (
    <form className="page-c">
      <div className="search-c">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text mt={8} variant="h1" label="Monthly Statement" />
          </div>
          <div className="grd-cell-none">
            <Button
              disabled={loading.search}
              loading={loading.search}
              type="search"
              label={loading.search ? 'Searching...' : 'Search'}
              onClick={handleSearch}
            />
          </div>
        </div>
        <div className="grd-row">
          <div className="grd-cell">
            <SelectMonth
              required={true}
              name="month"
              label="Month"
              placeholder="Month"
              type="Month"
              value={searchData.month}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell-none">
            <TextField
              required={true}
              max={4}
              name="year"
              label="Year"
              placeholder="Year"
              type="text"
              value={searchData.year}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteCorrespondent
              name="correspondent"
              value={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteBranch
              name="branch"
              value={searchData.branch}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteAccountNo
              name="accountNo"
              value={searchData.accountNo}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteMasterAccountNo
              name="masterAccountNo"
              value={searchData.masterAccountNo}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteRep
              name="rep"
              value={searchData.rep}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
          <div className="grd-cell">
            <AutoCompleteAccountName
              name="accountName"
              value={searchData.accountName}
              correspondent={searchData.correspondent}
              onChange={handleSearchDataChange}
            />
          </div>
        </div>
      </div>
      <div className="mt-20">
        <Table
          title={'Statement'}
          data={rows}
          columns={columns}
          options={options}
          getCsvData={getCsvData}
          pagination={pagination}
          setPagination={setPagination}
          onSearch={handleSearch}
        />
      </div>
      <ReportDownloadModal
        title={GridTitleStatement}
        selectedIds={[downloadData.accountId]}
        rows={tempFilteredRows}
        parameters={downloadData}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      />
    </form>
  );
}
